import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, useTheme } from "@mui/material";
import { COLORS } from "../../constants/colors";
import { useSelector } from "react-redux";
import { selectSideBarState } from "../../model/slice/sideBarSettingSlice";

const tabBase = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "150px",
};

const useStyles = ((theme) => ({
  tabContainer: {
    display: "flex",
    position: "fixed",
    top: "50px",
    zIndex: "999",
    backgroundColor: COLORS.tabSelectorColor,
  },
  tabBase: {
    position: "relative",
    zIndex: 50,
    height: "48px",
    width: "100%",
    [theme.breakpoints.down('sm')]: {
      height: "40px",
      borderRadius: "0 5px 5px 0",
    },
    backgroundColor: COLORS.tabSelectorColor,
    cursor: "pointer",
    display: "flex",
    "& p": {
      color: "#ffffff",
      fontSize: "12px",
      fontWeight: "500",
      fontFamily: "Inter",
      [theme.breakpoints.down('sm')]: {
        fontSize: "8px",
      },
    },
    "userSelect": "none",
    "MozUserSelect": "none",
    "WebkitUserSelect": "none",
  },
  tabFree: {
    ...tabBase,
    height: "100%",
    "& p": {
      opacity: 0.7,
    },
    borderBottom: "solid 6px rgba(1,1,1,0)",
  },
  tabSelected: {
    ...tabBase,
    height: "100%",
    "& p": {
      opacity: 1.0,
      color: "#19b2ab",
    },
    borderBottom: "solid 6px #19b2ab",
  },
}));

export const TabSelector = (props) => {
  const { tabs, selectedOne, clickHandler, children } = props;
  const sideBarStatus = useSelector(selectSideBarState);
  const theme = useTheme()
  const styles = useStyles(theme);
  const [isTop, setIsTop] = useState(true);

  useEffect(() => {
    const container = document.getElementById("TabContainer");

    const onScroll = () => setIsTop(container.offsetTop <= 52);

    window.addEventListener(
      "scroll",
      onScroll,
      true
    );
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <Box
      component={"div"}
      id="TabContainer"
      sx={{ 
        ...styles.tabContainer, 
        boxShadow: isTop ? "none" : "0px 4px 20px 0px rgba(0, 0, 0, 0.3)",
        width: "calc(100vw - 77px)",
        [theme.breakpoints.down('sm')]: {
          width: sideBarStatus ? "calc(100vw - 77px)" : "calc(100vw)",
        },
      }}
    >
      <Box component={"div"} sx={styles.tabBase}>
        {tabs.map((d) => (
          <Box
            component={"div"}
            sx={d.id === selectedOne ? styles.tabSelected : styles.tabFree}
            key={`tab-data-${d.id}`}
            onClick={() => clickHandler(d.id)}
          >
            <p>{d.name}</p>
          </Box>
        ))}
      </Box>
      {children}
    </Box>
  );
};

TabSelector.propTypes = {
  tabs: PropTypes.array,
  selectedOne: PropTypes.string || PropTypes.number,
  clickHandler: PropTypes.func,
  children: PropTypes.node,
};
